import styled from 'styled-components';

import { scrollbarX } from '../../styles/commonStyles';

const AXIS_WIDTH = 60;

const ChartViewport = ({ scale, axis, children }) => (
  <Viewport>
    <Row $scale={scale}>
      {axis && (
        <StickyAxis>
          <AxisInner>{axis}</AxisInner>
        </StickyAxis>
      )}
      <Track>{children}</Track>
    </Row>
  </Viewport>
);

export default ChartViewport;

const Viewport = styled.div`
  width: 100%;
  height: 100%;
  ${scrollbarX};
`;

const Row = styled.div`
  width: ${({ $scale }) => $scale * 100}%;
  height: 100%;
  display: flex;
`;

const StickyAxis = styled.div`
  position: sticky;
  left: 0;
  z-index: 2;
  flex: 0 0 ${AXIS_WIDTH}px;
  height: 100%;

  background: #233a54;
  overflow: hidden;
  pointer-events: none;
`;

const AxisInner = styled.div`
  width: 200px;
  height: 100%;
`;

const Track = styled.div`
  flex: 1 1 auto;
  height: 100%;
  min-width: 0;
`;
